export default __webpack_public_path__ + "static/media/forestly-expl-nn-intro_EN.2a8db0bd.png";